import { ItemCategory } from './item-category.model';
import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { SalePriceType } from './sale-price-type.model';

export class ItemPriceChange extends EntityBase {
    public CategoryIds?: number[];
    public CategoryTitles: string;
    public SalePriceTypeIds?: number[];
    public IncreaseRateOfAmount?: number;
    public AmountTypeId?: number;
    public ItemId: number;
    public AmountTypeTitle?: string;
    public AmountTypeCode?: number;
    public RoundingAmount?: number;
    public RoundingTypeId?: number;
    public RoundingTypeTitle: string;
    public RoundingTypeCode?: number;
    public ShamsiDateField: string;
    public Items: ItemPriceChangeDetail[];
}

export class ItemPriceChangeDetail extends EntityBase {
    public ItemPriceChangeId?: number;
    public ItemTitle: string;
    public ItemId: number;
    public ItemPriceId?: number;
    public CategoryTitle: string;
    public ItemCategory: ItemCategory;
    public SalePriceTypeId?: number;
    public SalePriceTypeTitle: string;
    public SalePriceType: SalePriceType;
    public PriceTypeId?: number;
    public OldAmount?: number;
    public NewAmount?: number;
    public IncreaseRateOfAmount?: number;
}
